// Lista „Nadchodzące” na stronie głównej (pages/home.js). Czysty moduł: bez Reacta i bez sieci,
// żeby regułę dało się sprawdzić testem bez montowania strony.
//
// Anulowane nie należą do „najbliższych wypożyczeń” (przegląd 28.09.2026). Wspólna lista
// GET /api/all-reservations oddaje je, bo kalendarz ma je pokazywać, więc odsiewa je dopiero
// strona główna. Status rozpoznaje jedna reguła panelu (utils/reservationStatus.js), nie własna
// kopia: angielskie „cancelled” ma odpadać tak samo jak „Anulowana”, a dwie kopie by się rozjechały.
import { isCancelledReservation } from './reservationStatus';

/** Czy rezerwacja z /api/all-reservations jest anulowana (status pod dowolną z dwóch nazw pola). */
export function czyAnulowana(rezerwacja) {
  return isCancelledReservation(rezerwacja);
}

/** Rezerwacje bez anulowanych; cokolwiek innego niż tablica (np. błąd zamiast listy) daje pustą listę. */
export function bezAnulowanych(rezerwacje) {
  if (!Array.isArray(rezerwacje)) return [];
  return rezerwacje.filter((r) => !czyAnulowana(r));
}
